import { Pipe, PipeTransform } from '@angular/core';

export interface IDutyStatus {
  driving: string;
  on_duty: string;
  off_duty: string;
  sleeper: string;
  ym: string;
  pc: string;
  waiting: string;
}

export const dutyStatuses: IDutyStatus = {
  driving: $localize`Driving`,
  on_duty: $localize`On Duty`,
  off_duty: $localize`Off Duty`,
  sleeper: $localize`Sleeper`,
  ym: $localize`Yard Move`,
  pc: $localize`Personal Conveyance`,
  waiting: $localize`Waiting`,
};

@Pipe({ name: 'dutyStatusLabel' })
export class DutyStatusLabelPipe implements PipeTransform {
  public transform(dutyStatus: string): string {
    return dutyStatuses[dutyStatus] || $localize`Duty Status Unknown`;
  }
}
